module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-tea-mill-finish-725-panel.cc239bdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-tea-mill-finish-725-panel.jpg
// module id = 1126
// module chunks = 37